export default {
  primary: {
    lighter: '#5088c4',
    default: '#326295',
    darker: '#254E70',
  },
  secondary: {
    lighter: '#b4d8ef',
    default: '#9bcbeb',
    darker: '#49a0da',
  },
  tertiary: {
    lighter: '#e27740',
    default: '#be531c',
    darker: '#8e3e15',
  },
  positive: {
    lighter: '#99cfac',
    default: '#78C091',
    darker: '#4a9f68',
  },
  negative: {
    lighter: '#ea6258',
    default: '#ea6258',
    darker: '#ea6258',
  },
  grayscale: {
    darker: '#121212',
    default: '#212121',
    lighter: '#535353',
  },
  warning: {
    darker: '#caba04',
    default: '#eab308',
    lighter: '#facc15',
  },
}
